import { Spin } from 'antd';

import './Spinner.scss';

export const Spinner = () => {
  return (
    <div className="spinner-container">
      <Spin />
    </div>
  );
};
